import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { GroupedShippingPricesView } from './GroupedShippingPricesView.js'
import { parseFormData } from '../../../utils/formsUtils'

export const GroupedShippingPrices = () => {
    const [totalPc, setTotalPc] = useState(0)
    const [weightedCost, setWeightedCost] = useState()
    const [countries, setCountries] = useState('EU')
    const [serviceType, setServiceType] = useState('untracked')
    const [selectedCountryCodes, setSelectedCountryCodes] = useState([])
    const [allIsoCountryCodes, setAllIsoCountryCodes] = useState()
    const [password, setPassword] = useState('')


    //fetch ISO country codes
    useEffect(() => {
        axios.get((process.env.REACT_APP_HOST + 'api/fixedData/isoCountryCodes'))
            .then((res) => {
                console.log(res.data)
                setSelectedCountryCodes(res.data.eu)
                setAllIsoCountryCodes(res.data)
            })
    }, [])



    const onSubmit = async (e) => {
        e.preventDefault()
        const formData = parseFormData(e)
        const obj = {}
        obj.formData = formData
        obj.region = countries
        obj.serviceType = serviceType

        axios
            .post(process.env.REACT_APP_HOST + 'api/pricing/groupedShippingPrices', { obj })
            .then((res) => {
                console.log(res.data)
                setWeightedCost(res.data)
                console.log(weightedCost)
            })

    }


    const onSelectCountry = (e) => {
        setCountries(e.target.value)
        if (e.target.value === 'EU') {
            setSelectedCountryCodes(allIsoCountryCodes.eu)
        } else if (e.target.value === 'ROW') {
            setSelectedCountryCodes(allIsoCountryCodes.row)
        }
    }

    const onSelectServiceType = (e) => {
        setServiceType(e.target.value)


    }

    return <GroupedShippingPricesView
        onSelectServiceType={onSelectServiceType}
        onSubmit={onSubmit}
        totalPc={totalPc}
        weightedCost={weightedCost}
        countries={countries}
        onSelectCountry={onSelectCountry}
        countryCodes={selectedCountryCodes}
        serviceType={serviceType}
        password={password}
        setPassword={setPassword}
    />
}

